var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"data-cy":"select-status","items":_vm.items,"label":_vm.label,"value":_vm.value,"outlined":"","id":"statSelect","disabled":_vm.disabled},on:{"change":_vm.emitValue}})}
var staticRenderFns = []

export { render, staticRenderFns }